import ChangePassword from "./Pages/ChangePassword";

function App() {
  return (
    <ChangePassword />
  );
}

export default App;
